import {
  Button,
  Col,
  DatePicker,
  Descriptions,
  Flex,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tabs,
  Typography,
} from 'antd';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import routesApi from '../../api/route';
import dayjs from 'dayjs';
import IntlMessage from '../../components/IntlMessage';
import reportApi from '../../api/report';
import Status from '../../components/Status';
import { getTagPaymentStatus } from '../order/payment.type';
import { useIntl } from 'react-intl';

const { Text } = Typography;

const PassengerByRoute = (props) => {
  const { id } = useParams();
  const [route, setRoute] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [mode, setMode] = useState('day');
  //   const [tabItems, setTabItems] = useState([]);
  const [passengers, setPassengers] = useState([]);
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await routesApi.getDetail(id);
        console.log('dayjs()', dayjs().format('DD-MM-YYYY'));
        let from = dayjs();
        let to = dayjs();
        from = from.subtract(2, 'day').startOf('day');
        to = to.add(6, 'day').endOf('day');

        setRange({ from, to });

        onChangeTab(dayjs().format('DD-MM-YYYY'));
        setRoute(res);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, [id]);
  console.log('passengers', passengers);
  const onChangeMode = (value) => {
    setMode(value);
    form.setFieldsValue({
      from_date:
        value === 'date' ? dayjs().subtract(2, 'day').startOf('day') : dayjs(),
      to_date: value === 'date' ? dayjs().add(6, 'day').endOf('day') : dayjs(),
    });
  };

  const [activeDate, setActiveDate] = useState(null); // Ngày đang chọn
  const [range, setRange] = useState({ from: null, to: null });

  const onSearch = () => {
    form.validateFields().then((values) => {
      let from = dayjs(values.from_date);
      let to = dayjs(values.to_date);

      if (mode === 'day') {
        const selected = dayjs(values.from_date);
        from = selected.subtract(2, 'day').startOf('day');
        to = selected.add(6, 'day').endOf('day');
      }
      setRange({ from, to });

      if (mode === 'date') {
        onChangeTab(from.format('DD-MM-YYYY'));
      } else {
        onChangeTab(dayjs(values.from_date).format('DD-MM-YYYY'));
      }
    });
  };

  const columns = [
    {
      title: 'Siège',
      dataIndex: 'seat',
    },
    {
      title: 'Prénom',
      dataIndex: 'fullname',
      render: (_, record) => {
        return record.firstname ? `${record.firstname}` : '';
      },
    },
    {
      title: 'Nom',
      dataIndex: 'fullname',
      render: (_, record) => {
        return record.lastname ? `${record.lastname}` : '';
      },
    },
    {
      title: 'Trajet',
      dataIndex: 'fullname',
      render: (_, record) => {
        return record?.order_items?.[0]
          ? `${record?.order_items?.[0]?.segment?.start_stop?.title}~${record?.order_items?.[0]?.segment?.end_stop?.title}`
          : '';
      },
    },
    {
      title: 'Téléphone',
      dataIndex: 'phone',
    },
    {
      title: 'CNI/Passeport',
      dataIndex: 'passport',
    },
    {
      key: 'pay_method',
      dataIndex: 'pay_method',
      title: <IntlMessage id="global.pay_method" />,
      render: (text, record) => {
        return record?.order?.pay_method;
      },
    },
    {
      key: 'pay_status',
      dataIndex: 'pay_status',
      title: <IntlMessage id="global.pay_status" />,
      render: (text, record) => {
        return (
          <Flex justify="center">{getTagPaymentStatus(record?.order)} </Flex>
        );
      },
    },
    {
      title: <IntlMessage id="global.order_no" />,
      key: 'order_no',
      dataIndex: 'order_no',
      width: 100,
      render: (text, record, index) => {
        return record?.order?.order_no;
      },
    },
    {
      title: '#',
      render: (text, record, index) => {
        return index + 1;
      },
    },
  ];

  const tabItems = useMemo(() => {
    console.log('rangerangerange', range);
    if (!range.from || !range.to) return [];

    const from = range.from.startOf('day');
    const to = range.to.endOf('day');
    const days = to.diff(from, 'day') + 1;

    return Array.from({ length: days }).map((_, index) => {
      const date = from.add(index, 'day').format('DD-MM-YYYY');
      return {
        key: date,
        label: date,
        children: (
          <>
            {loading ? (
              <Flex justify="center">
                <Spin />
              </Flex>
            ) : (
              <>
                {' '}
                <Table
                  dataSource={passengers}
                  columns={columns}
                  tableLayout="auto"
                  loading={loading}
                  bordered
                  scroll={{ x: 'max-content' }}
                  rowKey="id"
                  size="small"
                />
              </>
            )}
          </>
        ),
      };
    });
  }, [range, passengers, loading]);

  const onChangeTab = async (key) => {
    setActiveDate(key);
    setLoading(true);
    const res = await reportApi.getPassengerByRouteId(
      id,
      dayjs(key, 'DD-MM-YYYY').format('YYYY-MM-DD')
    );
    setPassengers(res);
    setLoading(false);
  };

  const [loadingExport, setLoadingExport] = useState(false);
  const intl = useIntl();
  const handleExportData = async () => {
    try {
      setLoadingExport(true);

      const response = await reportApi.exportDataExcel(
        id,
        dayjs(activeDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
      );

      console.log('response', response);
      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const fileName = `passengers_${dayjs(activeDate, 'DD/MM/YYYY').format(
        'DD-MM-YYYY'
      )}.xlsx`;

      link.setAttribute('download', fileName);
      // tên file tải về
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Lỗi xuất file Excel:', error);
      Modal.error({
        title: error,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
    } finally {
      setLoadingExport(false);
    }
  };

  const [loadingExportPdf, setLoadingExportPdf] = useState(false);
  const handleExportPdfData = async () => {
    // Modal.info({
    //   title: 'The function is in development',
    // });
    setLoadingExportPdf(true);
    await reportApi
      .exportDataPdf(id, dayjs(activeDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
      .then((data) => {
        setLoadingExportPdf(false);
        // window.open(data.data, '_blank');
      })
      .catch((error) => {
        console.error(error);
        setLoadingExportPdf(false);
        Modal.error({
          title: error,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
      })
      .finally(function () {
        setLoadingExportPdf(false);
      });
    setLoadingExportPdf(false);
  };

  const [open, setOpen] = useState(false);

  return (
    <Space style={{ width: '100%' }} direction="vertical" size={6}>
      <Space style={{ marginBottom: '20px' }} direction="vertical" size={6}>
        <div style={{ fontWeight: '700' }}>{route?.operator?.title}</div>
        <div style={{ fontWeight: '700' }}>
          {route?.start_location?.title} ~ {route?.end_location?.title}
        </div>
        <div>
          <IntlMessage id="global.depart_time" />:{' '}
          {dayjs(route.min_depart, 'HH:mm:ss').format('HH:mm')}
        </div>
        <div>
          <IntlMessage id="global.code" />: {route?.sku}
        </div>
        <div>
          <IntlMessage id="global.bus" />: {route?.seatmap?.title}
        </div>
      </Space>

      <Row justify="space-between">
        <Col>
          <Form layout="inline" form={form} onFinish={onSearch}>
            <Row justify={'start'}>
              <Col>
                <Form.Item
                  name={'mode'}
                  initialValue={'day'}
                  rules={[
                    {
                      required: true,
                      message: <IntlMessage id="global.requiredfeild" />,
                    },
                  ]}>
                  <Select
                    placeholder="Select mode"
                    onSelect={onChangeMode}
                    options={[
                      {
                        value: 'date',
                        label: <IntlMessage id="global.date" />,
                      },
                      {
                        value: 'day',
                        label: <IntlMessage id="global.day" />,
                      },
                    ]}></Select>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  name="from_date"
                  initialValue={dayjs()}
                  dependencies={['mode', 'to_date']}
                  rules={[
                    {
                      required: false,
                      message: <IntlMessage id="global.requiredfeild" />,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (getFieldValue('mode')) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error('Please select mode!!')
                        );
                      },
                    }),
                  ]}>
                  <DatePicker
                    placeholder="From"
                    format={'DD-MM-YYYY'}
                    picker={mode}
                  />
                </Form.Item>
              </Col>
              {mode === 'date' && (
                <Col>
                  <Form.Item
                    name="to_date"
                    initialValue={dayjs()}
                    dependencies={['mode', 'from_date']}
                    rules={[
                      {
                        required: false,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            (value && getFieldValue('from_date')) ||
                            !getFieldValue('from_date')
                          ) {
                            return Promise.resolve();
                          }

                          return Promise.reject(
                            new Error('Please select from date!!')
                          );
                        },
                      }),
                    ]}>
                    <DatePicker
                      placeholder="To"
                      format={'DD-MM-YYYY'}
                      picker={mode}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Chercher
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col>
          <Button type="primary" onClick={() => setOpen(true)}>
            <IntlMessage id="global.export" />
          </Button>
        </Col>
      </Row>

      <Tabs
        items={tabItems}
        activeKey={activeDate}
        onChange={(key) => onChangeTab(key)}
        destroyInactiveTabPane
        className="full-width-tabs"
      />

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        width={'40%'}
        className="modal_cashier"
        footer={[
          <>
            <Button key={'ok'} type="primary" onClick={() => setOpen(false)}>
              <IntlMessage id="global.ok" />
            </Button>
            ,
          </>,
        ]}>
        <>
          <Descriptions bordered>
            <Descriptions.Item
              label="Exporter avec PDF"
              span={3}
              labelStyle={{ width: '30%' }}>
              <Button
                type="primary"
                onClick={handleExportPdfData}
                loading={loadingExportPdf}>
                <IntlMessage id="global.export" />
              </Button>
            </Descriptions.Item>
            <Descriptions.Item
              label="Exporter avec XLSX"
              span={3}
              labelStyle={{ width: '30%' }}>
              <Button
                type="primary"
                onClick={handleExportData}
                loading={loadingExport}>
                <IntlMessage id="global.export" />
              </Button>
            </Descriptions.Item>
          </Descriptions>
        </>
      </Modal>
    </Space>
  );
};

export default PassengerByRoute;
